import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { withTranslate } from 'shared/hocs/withTranslate';

import { InputPhoneNumber, InputText, Button } from 'shared/components/UI';

import s from './CommonEmailForm.css';

class CommonEmailForm extends React.Component {
  static propTypes = {
    userName: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    carLocation: PropTypes.string.isRequired,
    errorMessage: PropTypes.string.isRequired,
    successMessage: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired,
    changeHandler: PropTypes.func.isRequired,
    onSubmitHandler: PropTypes.func.isRequired,
    disabledBtn: PropTypes.bool,

    title: PropTypes.string,
    subTitle: PropTypes.string,
    fillFormText: PropTypes.string,
    footerTitle: PropTypes.string,
    footerText: PropTypes.string,
    radioGroupId: PropTypes.string,
    isProcessing: PropTypes.bool,
    titleClassName: PropTypes.string,
  };

  static defaultProps = {
    disabledBtn: false,
    title: '',
    subTitle: '',
    fillFormText: '',
    footerTitle: '',
    footerText: '',
    radioGroupId: 'carLocation',
    isProcessing: false,
    titleClassName: '',
  };

  handleOptionChange = event => {
    event.stopPropagation();
    if (this.props.changeHandler instanceof Function) {
      this.props.changeHandler('carLocation', event.target.value);
    }
  };

  render() {
    const {
      userName,
      phone,
      carLocation,
      errorMessage,
      successMessage,
      t,
      changeHandler,
      onSubmitHandler,
      disabledBtn,
      // advert,

      title,
      subTitle,
      fillFormText,
      footerTitle,
      footerText,
      radioGroupId,
      isProcessing,
      titleClassName,
    } = this.props;

    const disabledButton = disabledBtn || !userName || !phone || !carLocation;
    return (
      <div className={s.containerCenter}>
        <div className={cx(s.title, titleClassName)}>
          {title}
          {subTitle && <div>{subTitle}</div>}
        </div>
        {fillFormText && <div className={s.subTitle}>{fillFormText}</div>}
        <form className={s.requestForm}>
          <InputPhoneNumber name={'phone'} value={phone} changeHandler={changeHandler} />
          <InputText
            name={'userName'}
            value={userName}
            placeholder={userName || t('Ваше имя')}
            changeHandler={changeHandler}
          />

          {(errorMessage || successMessage) && (
            <span
              className={cx(
                { [s.errorMessage]: errorMessage },
                { [s.successMessage]: successMessage },
              )}
            >
              {t(errorMessage || successMessage)}
            </span>
          )}

          {footerTitle && <div className={s.contentText}>{footerTitle}</div>}
          <div className={s.searchTypeBlock}>
            <label htmlFor={`${radioGroupId}-inUkraine`}>
              <input
                type="radio"
                id={`${radioGroupId}-inUkraine`}
                name="carLocation"
                value="inUkraine"
                checked={carLocation === 'inUkraine'}
                onChange={this.handleOptionChange}
              />
              {t('Поиск в Украине')}
            </label>

            <label htmlFor={`${radioGroupId}-abroad`}>
              <input
                type="radio"
                id={`${radioGroupId}-abroad`}
                name="carLocation"
                value="abroad"
                checked={carLocation === 'abroad'}
                onChange={this.handleOptionChange}
              />
              {t('Заказ из-за рубежа')}
            </label>

            <label htmlFor={`${radioGroupId}-both`}>
              <input
                type="radio"
                id={`${radioGroupId}-both`}
                name="carLocation"
                value="both"
                checked={carLocation === 'both'}
                onChange={this.handleOptionChange}
              />
              {t('Оба варианта')}
            </label>
          </div>
          {footerText && <div className={s.footer}>{footerText}</div>}

          <Button
            isProcessing={isProcessing}
            disabled={disabledButton}
            type="button"
            onClick={e => onSubmitHandler(e, 'call')}
            text={t('Отправить')}
          />
        </form>
      </div>
    );
  }
}

export default withStyles(s)(withTranslate(CommonEmailForm));



// WEBPACK FOOTER //
// ./src/shared/components/SuggestForDefaultAd/SuggestForm/CommonEmailForm.js